import { startOfMonth, endOfMonth, eachDayOfInterval, format, addMonths, getDay } from "date-fns";
import { pl } from "date-fns/locale";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ymd } from "@/lib/api";

const WD = ["Pn", "Wt", "Śr", "Cz", "Pt", "So", "Nd"];

export const MonthCalendar = ({ month, onMonthChange, isDisabled = () => false, selected, onSelect, renderMeta, canPrev = true, dayClass }) => {
  const days = eachDayOfInterval({ start: startOfMonth(month), end: endOfMonth(month) });
  const offset = (getDay(days[0]) + 6) % 7;
  const title = format(month, "LLLL yyyy", { locale: pl });
  return (
    <div data-testid="month-calendar">
      <div className="flex items-center justify-between mb-5">
        <button data-testid="calendar-prev-month" disabled={!canPrev} onClick={() => onMonthChange(addMonths(month, -1))}
          className="p-2 rounded-md hover:bg-white/5 disabled:opacity-25 transition-colors"><ChevronLeft size={18} /></button>
        <span data-testid="calendar-month-label" className="font-display font-semibold capitalize">{title}</span>
        <button data-testid="calendar-next-month" onClick={() => onMonthChange(addMonths(month, 1))}
          className="p-2 rounded-md hover:bg-white/5 transition-colors"><ChevronRight size={18} /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center text-xs text-muted-foreground mb-2">
        {WD.map((d) => <span key={d}>{d}</span>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: offset }).map((_, i) => <span key={`e${i}`} />)}
        {days.map((d) => {
          const ds = ymd(d);
          const dis = isDisabled(ds);
          const sel = selected === ds;
          return (
            <button key={ds} data-testid={`calendar-day-${ds}`} disabled={dis} onClick={() => onSelect(ds)}
              className={`relative aspect-square max-h-12 rounded-md text-sm flex flex-col items-center justify-center transition-colors
                ${sel ? "bg-primary text-primary-foreground font-bold" : dis ? "text-white/20 cursor-not-allowed" : "hover:bg-white/10"}
                ${dayClass ? dayClass(ds, sel) : ""}`}>
              {d.getDate()}
              {renderMeta && renderMeta(ds, sel)}
            </button>
          );
        })}
      </div>
    </div>
  );
};
